import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getReportedHoursBetweenDates = (
    token: string,
    backend: string,
    fromDate: string,
    toDate: string,
) => {
    return fetch(
        `${getApiUrl(backend)}reported_hours_between_dates/${fromDate}/${toDate}`,
        {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
};

export default getReportedHoursBetweenDates;
